import { AppTFunction } from '@retail/app/i18n';
import * as yup from 'yup';

export const CUSTOMER_NAME_MIN_LENGTH = 2;
export const CUSTOMER_NAME_MAX_LENGTH = 100;
const customerNamePattern = /^[\p{L}\p{N} .\-_&']+$/u;

export const createCustomerSchema = (t: AppTFunction) =>
  yup.object({
    name: yup
      .string()
      .trim()
      .required(t('app.createCustomer.error.required'))
      .min(
        CUSTOMER_NAME_MIN_LENGTH,
        t('app.createCustomer.error.minLength', { min: CUSTOMER_NAME_MIN_LENGTH })
      )
      .max(
        CUSTOMER_NAME_MAX_LENGTH,
        t('app.createCustomer.error.maxLength', { max: CUSTOMER_NAME_MAX_LENGTH })
      )
      .matches(customerNamePattern, t('app.createCustomer.error.invalidCharacters')),
    discountMatrixTemplateAssortmentId: yup.number().nullable().default(null),
    assortmentTemplateAssortmentId: yup.number().nullable().default(null),
  });

export type CreateCustomerSchema = yup.InferType<ReturnType<typeof createCustomerSchema>>;
